export const CONTACT_FORM_HASH_HREF = "#formularz";

export const TESTIMONIALS_HASH_HREF = "#opinie";

export const CONTACT_FORM_SUCCESS_MESSAGE =
  "Dziękujemy, odezwiemy się najszybciej jak to możliwe";

export const CONTACT_FORM_MESSAGE_PLACEHOLDER =
  "Napisz, jakie wydarzenie planujesz, na jaki termin i dla ilu gości. Wrócimy do Ciebie z ofertą.";

export const CONTACT_FORM_SUBMIT_LABEL = "Wyślij zapytanie";

export function isValidEmail(value: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
}

export function isValidPhone(value: string): boolean {
  const digits = value.replace(/\D/g, "");
  return digits.length >= 9 && digits.length <= 15;
}
